import { get } from '../config/$ajax.js';


export const getLingganVerify = (data = {}, params = {}) => {
  return get(`/linggan/verify`, data, params);
};

export const getLingganInfo = async() => {
  let res = await getLingganVerify();
  let obj = null;
  if (res && res.result === 1 && res.data) {
    const { data: { redirectUrl } } = res.data;
    if (redirectUrl) {
      try {
        const url = new URL(redirectUrl);
        obj = {
          href:url.origin,
          token:url.searchParams.get('token') || '',
        };
      } catch (e) {
        console.error('解析 redirectUrl 失败:', e);
      }
    }
  }
  return obj
}